/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { RefreshPlaylistsYoutubeMutationResponse, RefreshPlaylistsYoutubePathParams } from "../models/RefreshPlaylistsYoutube";

export function getRefreshPlaylistsYoutubeUrl(station: RefreshPlaylistsYoutubePathParams["station"]) {
  const res = { method: 'POST', url: `/youtube/${station}/playlists/refresh` as const }
  return res
}

/**
 * @description Bypasses cache and fetches fresh playlists from YouTube API, then caches the result
 * @summary Refresh YouTube playlists for a station
 * {@link /youtube/:station/playlists/refresh}
 */
export async function refreshPlaylistsYoutube(station: RefreshPlaylistsYoutubePathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RefreshPlaylistsYoutubeMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getRefreshPlaylistsYoutubeUrl(station).url.toString(), ... requestConfig })
  return res.data
}